<template>
	<div class="AccountsListBody">
		<div class="text-xs-center adderButtonContainer">
			<v-btn round color="teal" dark>BİR HESAP EKLE</v-btn>
		</div>
		<PlatformAccountsAccountLine v-for="n in 10" :key="n" :platform="platform"/>


		<v-dialog v-model="dialogNewAccount"   max-width="600px"> 
			<PlatformAccountsNewAccountInstagram v-if="platform == 'instagram'" />
		</v-dialog>

	</div>
</template>



<script>
	import PlatformAccountsAccountLine from "@/includes/Platform/Accounts/Account/Line"
	import PlatformAccountsNewAccountInstagram from "@/includes/Platform/Accounts/NewAccount/Instagram"

	export default {
		name  : 'ListBody',
		props : {
			platform : {
				type : String
			}
		}, 
		components : {
			PlatformAccountsAccountLine,
			PlatformAccountsNewAccountInstagram,
		},
		data : () => ({
			dialogNewAccount : false,
			editAccount : { },
		}),
		mounted(){
			this.setNewAccountData();
			if(this.platform == "instagram"){
				this.dialogNewAccount = true
			}
		},
		methods : {
			setNewAccountData(){
				this.editAccount = {
					account_unique : "",
					account_name : "",
					fullname : "",
					username : "",
					password : "",
					ip : "",
					port : "",
					protocol : "",
					token : "",
					logo : "",
					date_add : "",
					date_update  : "",
				}
			},
			openNewAccount(){
				this.setNewAccountData();
				this.dialogNewAccount = true
			}
		},
	}
</script>


<style lang="less">
	.AccountsListBody{
		padding: 20px 40px 40px 40px;
		background: #fff;
		@media(max-width:570px){
			padding:10px;
		}
	}
	.adderButtonContainer{
		margin-bottom: 20px;
	}
</style>
